{
    "title": "Flag Counts",
    "description": "JSON schema of discrete input data to timeSeries modules",
    "version": "0.14.0",
    "type": "array",
    "modules": {
        "sparkline": {
            "required": true
        },
        "timeSeries": {
            "required": true
        }
    },
    "items": {
        "type": "object",
        "required": [
            "GroupID",
            "MetricID",
            "n",
            "n_at_risk",
            "n_flagged",
            "n_at_risk_or_flagged"
        ],
        "properties": {
            "StudyID": {
                "title": "Study ID",
                "description": "Unique study identifier",
                "type": "string",
                "required": false,
                "key": true
            },
            "GroupID": {
                "title": "Group ID",
                "description": "Unique group identifier",
                "type": "string",
                "required": true,
                "key": true,
                "alternate": "MetricID"
            },
            "MetricID": {
                "title": "Metric ID",
                "description": "Unique workflow identifier",
                "type": "string",
                "required": true,
                "key": true,
                "alternate": "GroupID"
            },
            "n": {
                "title": "# of Groups/Metrics",
                "description": "Total number of assessed groups/Metrics",
                "type": "number",
                "required": true,
                "key": false
            },
            "n_at_risk": {
                "title": "# of Amber Groups/Metrics",
                "description": "Number of amber groups/Metrics",
                "type": "number",
                "required": true,
                "key": false
            },
            "n_flagged": {
                "title": "# of Red Groups/Metrics",
                "description": "Number of red groups/Metrics",
                "type": "number",
                "required": true,
                "key": false
            },
            "n_at_risk_or_flagged": {
                "title": "# of Amber of Red Groups/Metrics",
                "description": "Number of amber or red groups/Metrics",
                "type": "number",
                "required": true,
                "key": false
            }
        }
    }
}
